// Translate legacy codes too; a failed lookup never proves deletion or archival.
export const HOLD_CLEANING_EMAIL_OUTCOME_LABELS: Record<string, string> = {
  EXPIRED_OR_ARCHIVED_CANDIDATE: "Message not found — older than 30 days",
  MESSAGE_NOT_FOUND_OLDER_THAN_30_DAYS: "Message not found — older than 30 days",
  SOURCE_UNAVAILABLE_RECENT: "Message not found — within 30 days",
  SOURCE_UNAVAILABLE_UNKNOWN_DATE: "Message not found — date unknown",
  INVALID_MESSAGE_ID: "Invalid message identifier",
  TRANSIENT_NETWORK: "Request timed out or connection failed",
  UPSTREAM_SERVER: "Upstream service error",
};
